module.exports = __webpack_public_path__ + "ws.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ws.svg
// module id = 890
// module chunks = 0